import { socialLinks } from '../constants/socialLinks';

export const defaultMarkup = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://www.boldare.com/about/',
  foundingDate: '2004',
  description:
    'Boldare is a product design and development company focused on digital transformation, driven by purpose and empowering employees.',
  founders: [
    {
      '@type': 'Person',
      name: 'Anna Zarudzka',
      jobTitle: 'Co-CEO',
    },
    {
      '@type': 'Person',
      name: 'Piotr Majchrzak',
      jobTitle: 'Co-CEO',
    },
  ],
  sameAs: Object.values(socialLinks),
};
